import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/effect-coverflow'

import { useEffect, useRef, useState } from 'react'
import { Parallax } from 'react-parallax'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import arrow from 'assets/icon/Arrow 1 (Stroke).png'
import arrowIcon from 'assets/icon/arrow-circle.png'
import autocallIcon from 'assets/icon/service/img_auto_76.png'
import familycareIcon from 'assets/icon/service/img_care_76.png'
import couponWalletIcon from 'assets/icon/service/img_cp_76.png'
import eventuIcon from 'assets/icon/service/img_event_76.png'
import mfinderIcon from 'assets/icon/service/img_find_76.png'
import mnalistIcon from 'assets/icon/service/img_mna_76.png'
import antiscamIcon from 'assets/icon/service/img_sfb_76.png'
import familycareFullPageImg from 'assets/images/main/familycare_fullpage_img.png'
import historyImg from 'assets/images/main/glass-office-building-view-of-the-sky-reflected-in-the-windows 2.png'
import patentImg from 'assets/images/main/image 286.png'
import duMadeImg from 'assets/images/main/img_DU-Made_1920.png'
import recruitImg from 'assets/images/main/img_home-recruit_1600.png'
import antiscamImage2 from 'assets/images/main/img_Section-01_anti_1200.png'
import antiscamImage1 from 'assets/images/main/img_Section-01_anti_1920.png'
import mfinderImage1 from 'assets/images/main/img_Section-02_mfinder.png'
import autocallImage1 from 'assets/images/main/img_Section-03_auto.png'
import couponWalletImage1 from 'assets/images/main/img_Section-04_coin.png'
import eventuImage1 from 'assets/images/main/img_Section-05_eventu.png'
import couponWalletFullPageImg from 'assets/images/main/img_Section-06_coupon.png'
import mnalistBuilding from 'assets/images/main/img_Section-07_buliding.png'
import mnalistImage1 from 'assets/images/main/img_Section-07_mnalist.png'
import mainMotion from 'assets/json/datauniverse-main-logo.json'
import serviceMotion1 from 'assets/json/img_Section-01_pin_160.json'
import serviceMotion2 from 'assets/json/img_Section-02_pin_710.json'
import serviceMotion3 from 'assets/json/img_Section-03_car_700.json'
import serviceMotion4 from 'assets/json/img_Section-03_smile_250.json'
import serviceMotion5 from 'assets/json/img_Section-04_heart_700.json'
import serviceMotion8 from 'assets/json/img_Section-04_wallet_700.json'
import serviceMotion6 from 'assets/json/img_Section-05_box1_1000.json'
import serviceMotion7 from 'assets/json/img_Section-05_box2_1200.json'
import serviceMotion9 from 'assets/json/img_Section-07_mnalist.json'
import mainVideo1 from 'assets/video/DU_main01.mp4'
import mainVideo2 from 'assets/video/DU_main02.mp4'
import mainVideo3 from 'assets/video/DU_main03.mp4'
import mainServiceBg from 'assets/video/main_service_bg.mp4'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lottie from 'lottie-react'
import lottie from 'lottie-web'
import { useSetRecoilState } from 'recoil'
import { getPatentAndNewsList } from 'shared/api/fetchs'
import SeoHelmet from 'shared/components/common/SeoHelmet'
import TopButton from 'shared/components/common/TopButton'
import STYLE_GUIDE from 'shared/constants/color'
import { headerBlurFlag } from 'shared/store/index'
import styled, { keyframes } from 'styled-components'
import { MainButton1, MainButton2 } from 'styles/common/button'
import { EffectFade, Mousewheel } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

gsap.registerPlugin(ScrollTrigger)

const Home = () => {
  const [mainNews, setMainNews] = useState()
  const [selectVideo, setSelectVideo] = useState()
  const [sloganFlag, setSloganFlag] = useState(true)
  const [touchHeight, setTouchHeight] = useState(0)
  const [swiperIndex, setSwiperIndex] = useState(0)
  const [videoFlag, setVideoFlag] = useState(false)
  const setBlur = useSetRecoilState(headerBlurFlag)
  const historyRef = useRef()
  const patentRef = useRef()
  const swiperRef = useRef()
  const carLottieRef = useRef()

  const isMobile = useMediaQuery({
    query: '(min-width:1200px)',
  })
  const isMobile2 = useMediaQuery({
    query: '(max-width:1199px)',
  })

  const videoSource = [
    { idx: 0, source: mainVideo1 },
    { idx: 1, source: mainVideo2 },
    { idx: 2, source: mainVideo3 },
  ]
  const video = localStorage.getItem('mainVideo')

  const enableSwiper = () => {
    const swiper = document.getElementsByClassName('swiper-vertical')[0]
    swiper.style.touchAction = 'pan-x'
    swiperRef.current.swiper?.enable()
    setBlur(false)
    const eventuWrapper = document.querySelector('.eventu_image_wrapper')
    if (eventuWrapper) {
      gsap.to(eventuWrapper, { y: '0', duration: 1 })
    }
  }

  const disableSwiper = () => {
    const swiper = document.getElementsByClassName('swiper-vertical')[0]
    swiper.style.touchAction = 'pan-y'
    swiperRef.current.swiper?.disable()
  }

  const handleMouseEnter = (type) => {
    switch (type) {
      case 'history':
        historyRef.current.classList.add('active')
        break
      case 'patent':
        patentRef.current.classList.add('active')
        break
      default:
        break
    }
  }

  const handleMouseLeave = (type) => {
    switch (type) {
      case 'history':
        historyRef.current.classList.remove('active')
        break
      case 'patent':
        patentRef.current.classList.remove('active')
        break
      default:
        break
    }
  }

  const getNewsData = async () => {
    const mainNewsData = await getPatentAndNewsList('NEWS', 2, 0)
    setMainNews(mainNewsData[0])
  }

  const popIconClick = () => {
    if (swiperRef.current.swiper.isEnd) {
      goStory()
      setBlur(true)
      disableSwiper()
    } else {
      swiperRef.current.swiper.slideToLoop(swiperIndex + 1)
    }
  }

  const elementRef = useRef(null)
  const scrollHandler = (e) => {
    let st = window.scrollY || document.documentElement.scrollTop
    if (e.type === 'wheel') {
      if (st === 0 && !swiperRef.current.swiper?.enabled && e.deltaY < 0) {
        enableSwiper()
      }
      return
    }
    if (st === 0 && !swiperRef.current.swiper.enabled) {
      enableSwiper()
    } else {
      /*console.warn(`scrollHandler: st: ${st}, enabled: ${swiperRef.current.swiper.enabled}` )
                                    disableSwiper()*/
    }

    if (st > 0 && !swiperRef.current.swiper.enabled) {
      setBlur(true)
      /*gsap.to('.eventu_image_wrapper',
                                      {y: '-100%', duration: 1}
                                    )*/
    }
  }

  let startTouchY = 0
  let endTouchY = 0
  const touchStartHandler = (e) => {
    startTouchY = e.changedTouches[0].clientY
  }

  const touchEndHandler = (e) => {
    endTouchY = e.changedTouches[0].clientY
    setTouchHeight(Math.trunc(startTouchY) - Math.trunc(endTouchY))
  }

  useEffect(() => {
    if (touchHeight > 0 && swiperRef.current.swiper.enabled && swiperRef.current.swiper.isEnd) {
      disableSwiper()
    } else if (!swiperRef.current.swiper.enabled && window.scrollY === 0) {
      enableSwiper()
    }
  }, [touchHeight])

  useEffect(() => {
    setBlur(false)
    getNewsData()

    lottie.loadAnimation({
      container: document.querySelector('.test_lottie'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: mainMotion,
    })

    if (!video || video === '2') {
      localStorage.setItem('mainVideo', '0')
      setSelectVideo(videoSource[0].source)
    } else {
      localStorage.setItem('mainVideo', parseInt(video) + 1)
      const temp = videoSource.filter((s) => s.idx === parseInt(video) + 1)
      setSelectVideo(temp[0].source)
    }

    window.addEventListener('scroll', scrollHandler)
    window.addEventListener('wheel', scrollHandler)
    window.addEventListener('touchstart', touchStartHandler)
    window.addEventListener('touchend', touchEndHandler)

    return () => {
      window.removeEventListener('scroll', scrollHandler)
      window.removeEventListener('wheel', scrollHandler)
      window.removeEventListener('touchstart', touchStartHandler)
      window.removeEventListener('touchend', touchEndHandler)
    }
  }, [])

  useEffect(() => {
    setTimeout(function () {
      hideAllAni()
      if (swiperIndex > 0) {
        setVideoFlag(true)
      } else {
        setVideoFlag(false)
      }
      if (swiperIndex === 1) {
        if (sloganFlag) {
          commonAni()
          setSloganFlag(false)
        }
      } else {
        commonAni()
      }
    }, 950)
  }, [swiperIndex])

  const hideAllAni = () => {
    const imageWrappers = document.getElementsByClassName('image_wrapper')
    for (let i = 0; i < imageWrappers.length; i++) {
      imageWrappers[i].style.opacity = 0
    }
  }

  const commonAni = () => {
    if (swiperIndex === 1) {
      const fadeinEls = document.querySelectorAll('.caption')
      fadeinEls.forEach(function (textanimation, index) {
        gsap.fromTo(
          textanimation,
          { opacity: 0, y: 80 },
          { opacity: 1, y: 0, duration: 0.7, delay: index === 2 ? 0.1 : (index + 1) * 0.1 },
        )
      })
      return
    }

    const aniTarget = document.querySelectorAll('.image_wrapper')[swiperIndex - 2]
    if (!aniTarget) return

    const check = swiperRef.current.swiper.previousIndex - swiperIndex
    if (check < 0) {
      // 위로 올라감
      gsap.fromTo(
        aniTarget,
        { opacity: 0, y: '100%' },
        { opacity: 1, y: 0, duration: 0.7, onComplete: goLottie },
      )
    } else {
      // 아래로 내려감
      gsap.fromTo(
        aniTarget,
        { opacity: 0, y: '-100%' },
        { opacity: 1, y: 0, duration: 0.7, onComplete: goLottie },
      )
    }
  }

  const goLottie = () => {
    switch (swiperIndex) {
      case 3:
        if (carLottieRef?.current.animationItem.playCount === 0) {
          carLottieRef.current.animationItem.playCount = 1
          carLottieRef.current.setSpeed(2)
          carLottieRef.current.goToAndPlay(0, true)
        }
        break
      default:
        break
    }
  }

  const goStory = () => {
    const section = document.querySelector('.story_section')

    const toScroll = section.offsetTop - document.querySelector('.header').offsetHeight

    window.scrollTo({ top: toScroll, behavior: 'smooth' })
  }

  return (
    <>
      <SeoHelmet />
      <div>
        <MainWrap className="main_wrap">
          {videoFlag && (
            <div className={'main_service_bg'}>
              <video
                className="video"
                src={mainServiceBg}
                autoPlay={true}
                loop
                muted
                playsInline="playsinline"
              />
            </div>
          )}
          <Swiper
            ref={swiperRef}
            direction={'vertical'}
            slidesPerView={1}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 1,
            }}
            speed={1000}
            modules={[Mousewheel, EffectFade]}
            allowTouchMove={true}
            // effect={'fade'}
            // fadeEffect={{
            //   crossFade: true
            // }}
            // touchReleaseOnEdges={true}
            onSlideChange={(swiper) => {
              setTimeout(function () {
                setSwiperIndex(swiper.activeIndex)
              }, 50)
            }}
            onReachEnd={(swiper) => {
              setTimeout(function () {
                disableSwiper()
              }, 1000)
            }}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="main_banner_section">
                <video
                  className="video"
                  src={selectVideo}
                  autoPlay={true}
                  loop
                  muted
                  playsInline="playsinline"
                />
                <div className="test_lottie" style={{ position: 'absolute' }}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
                <h1 className="visually-hidden">
                  데이터로 만들어가는 세상, Data로 만들어가는 Universe, DataUniverse가 함께 합니다.
                  개인을 보호하고 사람과 함께하며 행복이 계속되는 세상, DataUniverse.
                </h1>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <SubSection1 className="du_made_section">
                <div className="container" style={{ position: 'relative', height: '100%' }}>
                  <div className="content_wrap slogan">
                    <div className={'contents'}>
                      <h2 className={'caption'}>DU Made</h2>
                      <div className="content caption">
                        <h3>
                          {isMobile2 ? '' : '데이터유니버스는 '}금융사기, 휴대폰분실, 개인정보유출,
                          가족돌봄 및 소통 부족 등 {isMobile2 ? '' : <br />}
                          사회문제를 해결하기 위해 정보통신기술(ICT) 분야의 기술력과 서비스 경험을
                          바탕으로 {isMobile2 ? '' : <br />}웹 3.0시대에 맞는 지능적이고 발전된
                          Global 서비스를 만들어갑니다.
                        </h3>
                        <MainButton2 className="du_button caption">
                          <Link to="information" state={{ state: 3 }}>
                            더 나은 세상을 위한 DU의 발자취
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                  <div className="pop_icon" onClick={popIconClick}>
                    <img src={arrowIcon} alt="" />
                  </div>
                </div>
              </SubSection1>
            </SwiperSlide>
            <SwiperSlide>
              {/*{
                (isIos) &&
                  <Lottie
                      animationData={serviceBackground}
                      style={{zIndex:'0', position:'absolute'}}
                  />
            }*/}
              <section className="service service1">
                <div className="lottie_bg lottie_color1"></div>
                <div className="mfinder_section">
                  <div className={'image_contents'}>
                    <div className="image_wrapper mfinder_image_wrapper">
                      <img src={mfinderImage1} alt="" className="image1" />
                      <Lottie animationData={serviceMotion2} className="pin2" />
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        잃어버린 휴대폰을
                        <br />
                        신속하게 찾아주는!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={mfinderIcon} alt="" />
                          <h3 className="service_name">휴대폰분실보호</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 1 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
            <SwiperSlide>
              {/*{
                (isIos) &&
                  <Lottie
                      animationData={serviceBackground}
                      style={{zIndex:'0', position:'absolute'}}
                  />
            }*/}
              <section className="service service2">
                <div className="lottie_bg lottie_color2"></div>
                <div className="anti_section">
                  <Lottie
                    animationData={serviceMotion1}
                    style={{ zIndex: '0', position: 'absolute' }}
                    className={'pin'}
                  />
                  <div className={'image_contents'}>
                    <div className="image_wrapper anti_image_wrapper">
                      {isMobile ? (
                        <img src={antiscamImage1} alt="" className="image1" />
                      ) : (
                        <img src={antiscamImage2} alt="" className="image1" />
                      )}
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        보이스피싱으로부터
                        <br />
                        나와 가족을 안전하게!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={antiscamIcon} alt="" />
                          <h3 className="service_name">스마트피싱보호</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 2 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
            <SwiperSlide>
              {/*{
                (isIos) &&
                  <Lottie
                      animationData={serviceBackground}
                      style={{zIndex:'0', position:'absolute'}}
                  />
            }*/}
              <section className="service service3">
                <div className="lottie_bg lottie_color3"></div>
                <div className="familycare_section">
                  <div className={'image_contents'}>
                    <div className={'image_wrapper familycare_image_wrapper'}>
                      <Lottie animationData={serviceMotion5} className="heart" />
                      <img src={familycareFullPageImg} alt="" className="familycareImg" />
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        언제 어디서든
                        <br />
                        우리가족 안부확인!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={familycareIcon} alt="" />
                          <h3 className="service_name">휴대폰가족보호</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 3 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
            <SwiperSlide>
              {/*{
                (isIos) &&
                  <Lottie
                      animationData={serviceBackground}
                      style={{zIndex:'0', position:'absolute'}}
                  />
            }*/}
              <section className="service service4">
                <div className="lottie_bg lottie_color4"></div>
                <div className="familycare_section">
                  <div className={'image_contents'}>
                    <div className={'image_wrapper '}>
                      <Lottie animationData={serviceMotion8} className="wallet" />
                      <img
                        src={couponWalletFullPageImg}
                        alt=""
                        className="couponWalletImg image1"
                      />
                      <img src={couponWalletImage1} alt="" className="couponWallet1" />
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        모바일 쿠폰 매일 할인 중
                        <br />
                        관리까지 스마트하게!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={couponWalletIcon} alt="" />
                          <h3 className="service_name">휴대폰쿠폰지갑</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 4 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section ref={elementRef} className="service service5" id="section1">
                <div className="lottie_bg lottie_color5"></div>
                <div className="eventu_section">
                  <div className={'image_contents'}>
                    <div className={'image_wrapper eventu_image_wrapper'}>
                      <Lottie animationData={serviceMotion6} className={'box1'} />
                      <Lottie animationData={serviceMotion7} className={'box2'} />
                      <img src={eventuImage1} alt="" className="image1" />
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        경품 이벤트를 한눈에
                        <br />
                        포인트로 추가 혜택까지!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={eventuIcon} alt="" />
                          <h3 className="service_name">이벤트유</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 5 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
            <SwiperSlide>
              {/*{
                (isIos) &&
                  <Lottie
                      animationData={serviceBackground}
                      style={{zIndex:'0', position:'absolute'}}
                  />
            }*/}
              <section className="service service6">
                <div className="lottie_bg lottie_color6"></div>
                <div className="autocall_section">
                  <div className={'image_contents'}>
                    <div className={'image_wrapper autocall_image_wrapper'}>
                      <Lottie
                        lottieRef={carLottieRef}
                        animationData={serviceMotion3}
                        className="car"
                        loop={false}
                        autoplay={false}
                      />
                      <Lottie animationData={serviceMotion4} className="smile" />
                      <img src={autocallImage1} alt="" className="image1" />
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        번호노출, 통화없는
                        <br />
                        운전자 호출 서비스!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={autocallIcon} alt="" />
                          <h3 className="service_name">오토콜</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 6 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
            <SwiperSlide>
              <section className="service service7">
                <div className="lottie_bg lottie_color7"></div>
                <div className="mnalist_section">
                  <div className={'image_contents'}>
                    <div className={'image_wrapper mnalist_image_wrapper'}>
                      <img src={mnalistBuilding} alt="" className="building" />
                      <Lottie animationData={serviceMotion9} className="briefcase" />
                      <img src={mnalistImage1} alt="" className="image1" />
                    </div>
                  </div>
                  <div className="desc_container" style={{ position: 'relative', height: '100%' }}>
                    <div className="left_section">
                      <h2 className="service_title">
                        복잡한 기업 매각 / 인수
                        <br />
                        M&A 전문가와 함께!
                      </h2>
                      <div className="bottom_area">
                        <div className="icon_area">
                          <img src={mnalistIcon} alt="" />
                          <h3 className="service_name">M&ALIST</h3>
                        </div>
                        <MainButton2 className="du_button">
                          <Link to={'/service'} state={{ section: 7 }}>
                            자세히 보기
                          </Link>
                        </MainButton2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'shadow'}></div>
                <div className="pop_icon" onClick={popIconClick}>
                  <img src={arrowIcon} alt="" />
                </div>
              </section>
            </SwiperSlide>
          </Swiper>

          <SubSection4 className="ss container story_section">
            <h2 className="title">Our Story</h2>
            <div className="story_box">
              <Link
                className="story_item"
                ref={historyRef}
                onMouseEnter={() => handleMouseEnter('history')}
                onMouseLeave={() => handleMouseLeave('history')}
                to={'information'}
                state={{ state: 3 }}
              >
                <div className="box">
                  <figure className="img_box">
                    <img src={historyImg} alt="" />
                  </figure>
                </div>
                <div className="story_content">
                  <h3>히스토리</h3>
                  <figure>
                    <img src={arrow} alt="" />
                  </figure>
                </div>
                <p>더 나은 세상을 위한 노력</p>
              </Link>
              <Link
                className="story_item"
                ref={patentRef}
                onMouseEnter={() => handleMouseEnter('patent')}
                onMouseLeave={() => handleMouseLeave('patent')}
                to={'information'}
                state={{ state: 2 }}
              >
                <div className="box">
                  <figure className="img_box">
                    <img src={patentImg} alt="" />
                  </figure>
                </div>
                <div className="story_content patent">
                  <h3>특허 및 인증</h3>
                  <figure>
                    <img src={arrow} alt="" />
                  </figure>
                </div>
                <p>끊임없는 도전 및 혁신</p>
              </Link>
            </div>
          </SubSection4>
          <SubSection2 className="ss news_section">
            <div className="container">
              <div className="content_wrap">
                <h2>News</h2>
                <div className="news_wrap">
                  <h3>{mainNews?.Title}</h3>
                  <p className="news_content">{mainNews?.Description}</p>
                  <MainButton1 className="news_button">
                    <a href={mainNews?.LinkPath} target="_blank" rel="noreferrer">
                      뉴스 기사 보기
                    </a>
                  </MainButton1>
                </div>
              </div>
            </div>
          </SubSection2>
          <SubSection5 className="ss recruit_section container">
            <Parallax
              className="recruit"
              bgImage={recruitImg}
              strength={300}
              bgImageStyle={{ minWidth: '1095px', minHeight: '730px' }}
            >
              <div className="">
                <h2 className="recruit_title">우리와 함께 일해요</h2>
                <div className="recruit_content">
                  <p>더 나은 세상을 만들기 위해, {!isMobile && <br />}데이터유니버스와 함께</p>
                </div>
                <div className="recruit_btn">
                  <MainButton2>
                    <Link to="recruit">채용안내 확인</Link>
                  </MainButton2>
                </div>
              </div>
            </Parallax>
          </SubSection5>
          <TopButton scroll={swiperRef} />
        </MainWrap>
      </div>
    </>
  )
}
export default Home

const setBoundFrames = keyframes`
    from {
        transform: translate3d(0, 0, 0);
    }
    to {
        transform: translate3d(0, -15px, 0);
    }
`

const MainWrap = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;

  .swiper {
    z-index: 1;
    height: 100vh;

    .swiper-wrapper {
      .swiper-slide {
        margin-bottom: 0 !important;
      }
    }
  }

  .test_lottie {
    width: 900px;
    height: 100%;
  }

  .main_service_bg {
    height: 100vh;
    width: 100vw;
    z-index: 0;
    position: absolute;
  }

  video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .main_banner_section {
    // height: 1050px;
    height: 100vh;
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;

    svg {
      // height: auto !important;
      position: absolute;
    }
  }

  .du_made_section {
    //height: 680px;
    height: 100vh;
  }

  .news_section {
    height: 518px;
    background: ${STYLE_GUIDE.COLOR.black2};
    color: ${STYLE_GUIDE.COLOR.white};
  }

  .service_section {
    height: 100vh;
  }

  .pop_icon {
    cursor: pointer;
    position: absolute;
    bottom: 20px;
    animation: ${setBoundFrames} 0.6s;
    animation-direction: alternate;
    animation-timing-function: cubic-bezier(0.2, 0.5, 0.5, 0.5);
    animation-iteration-count: infinite;
    left: calc(50% - 25px);
  }

  .swiper-slide > div > svg {
    height: auto !important;
    width: auto !important;
  }

  v .swiper-slide {
    //-webkit-backface-visibility: hidden;
    //-webkit-transform: translate3d(0, 0, 0);
  }

  .lottie_bg {
    opacity: 80%;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
  }

  .service_container {
    width: 500%;
    height: 100vh;
    display: flex;
    flex-wrap: noWrap;
  }

  .service {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;

    .anti_section,
    .mfinder_section,
    .familycare_section,
    .eventu_section,
    .autocall_section,
    .mnalist_section {
      width: 100%;
      height: 100%;

      .image_contents {
        width: 100%;
        height: 100%;
        top: 50% !important;
        transform: translate(0px, -50%) !important;
        position: absolute;
        opacity: 1;
      }

      .image_wrapper {
        opacity: 0;
        width: 100%;
        height: 100%;
      }
    }

    .desc_container {
      width: 100%;
      margin: 0 auto;
      max-width: 1600px;
    }

    .left_section {
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translate(0, -50%);

      .service_title {
        font-weight: 700;
        font-size: 56px;
        line-height: 72px;
        color: #ffffff;
      }

      .icon_area {
        padding: 50px 0 120px;
        display: flex;
        text-align: center;
        align-items: center;

        img {
          width: 76px;
        }

        .service_name {
          padding: 0 0 0 20px;
          font-weight: 400;
          font-size: 36px;
          line-height: 48px;
          color: #ffffff;
        }
      }
    }
  }

  .service2 {
    .pin {
      width: 4%;
      right: 50%;
      position: absolute;
      z-index: 2;
    }

    .image1 {
      position: absolute;
      z-index: 1;
      top: 50%;
      width: 50%;
      right: 5%;
      transform: translate(0px, -50%);
    }

    .image2 {
      position: absolute;
      right: 51%;
      top: 70%;
      transform: translate(0px, -50%);
    }
  }

  .service1 {
    .image1 {
      right: 120px;
      position: absolute;
      z-index: 1;
      top: 50%;
      width: 40%;
      transform: translate(0px, -40%);
    }

    .pin2 {
      top: 54%;
      z-index: 2;
      width: 18%;
      right: 38.5%;
      position: absolute;
    }
  }

  .service6 {
    .car {
      right: -5%;
      position: absolute;
      /* bottom: 0px; */
      z-index: 2;
      top: 50%;
      transform: translate(0px, 50%);
    }

    .smile {
      transform: translate(0px, 60%);
      width: 7.5%;
      right: 30%;
      /* right: 24%; */
      position: absolute;
      /* top: 83px; */
      z-index: 2;
    }

    .image1 {
      position: absolute;
      /* top: 30px; */
      z-index: 1;
      top: 50%;
      width: 50%;
      transform: translate(70%, -50%);
    }
  }

  .service7 {
    .image1 {
      position: absolute;
      z-index: 1;
      top: 54%;
      right: 0;
      transform: translate(6%, -50%);
    }

    .building {
      position: absolute;
      z-index: 2;
      width: 16.9%;
      left: 40%;
      top: 70%;
      transform: translate(0, -50%);
    }

    .briefcase {
      position: absolute;
      z-index: 2;
      width: 25%;
      right: 0;
      top: 10%;
    }
  }

  .service3 {
    .heart {
      width: 19%;
      right: 40%;
      position: absolute;
      bottom: 0;
      z-index: 2;
      top: 72%;
      transform: translate(10%, -50%);
    }

    .familycareImg {
      width: 1000px;
      position: absolute;
      z-index: 1;
      top: 58%;
      right: 15%;
      transform: translate(20%, -50%);
    }
  }

  .service4 {
    .wallet {
      max-width: 350px;
      max-width: 350px;
      width: 16.5%;
      top: 48%;
      right: 44%;
      position: absolute;
      bottom: 0;
      z-index: 2;
      transform: translate(10%, -50%);
    }

    .couponWalletImg {
      width: 47%;
      position: absolute;
      z-index: 1;
      top: 50%;
      right: 15%;
      transform: translate(20%, -50%);
    }

    .couponWallet1 {
      max-width: 405px;
      width: 19%;
      position: absolute;
      top: 66%;
      right: 47%;
      transform: translate(20%, -50%);
    }
  }

  .service5 {
    .box1 {
      right: 46%;
      width: 19%;
      bottom: 0;
      position: absolute;
      top: 65%;
      transform: translate(0px, -50%);
      z-index: 1;
    }

    .box2 {
      right: 0%;
      width: 30%;
      bottom: 0;
      position: absolute;
      top: 60%;
      transform: translate(0px, -50%);
      z-index: 2;
    }

    .image1 {
      position: absolute;
      z-index: 1;
      top: 50%;
      right: 50%;
      transform: translate(83%, -50%);
      width: 50%;
    }
  }

  .lottie_color1 {
    background-color: #67c51d;
  }

  .lottie_color2 {
    background-color: #006d3f;
  }

  .lottie_color3 {
    background-color: #e3112a;
  }

  .lottie_color4 {
    background-color: #1b5fdc;
  }

  .lottie_color5 {
    background-color: #6111e3;
  }

  .lottie_color6 {
    background-color: #008cc8;
  }

  .lottie_color7 {
    background-color: #003984cc;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    //.main_service_bg {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
    .test_lottie {
      width: 720px;
    }

    .service {
      .desc_container {
        max-width: 1000px;
      }
    }

    .service2 {
      .pin {
        width: 4%;
        right: 38%;
      }

      .image2 {
        top: 62%;
        width: 13%;
      }
    }

    .service1 {
      .image1 {
        width: 40%;
        right: 30%;
        transform: translate(50%, -50%);
      }

      .pin2 {
        top: 47.5%;
        right: 42%;
      }
    }

    .service6 {
      .smile {
        right: 20%;
        top: 30%;
        transform: translate(0px, -50%);
      }

      .car {
        width: 30%;
        top: 52%;
      }

      .image1 {
        width: 50%;
        transform: translate(90%, -50%);
      }
    }

    .service7 {
      .image1 {
        width: 73%;
      }

      .building {
        width: 18%;
        left: 38%;
      }

      .briefcase {
        width: 22%;
        top: 26%;
      }
    }

    .service3 {
      .heart {
        top: 67%;
      }

      .familycareImg {
        width: 50%;
        top: 56%;
        right: 10%;
      }
    }

    .service4 {
      .wallet {
        top: 53%;
        right: 43%;
      }

      .couponWalletImg {
        width: 50%;
        top: 48%;
        right: 8%;
      }

      .couponWallet1 {
        top: 64%;
        right: 47%;
      }
    }

    .service5 {
      .image1 {
        width: 50%;
        top: 52%;
      }
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    //.main_service_bg {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
    .test_lottie {
      width: 658px;
    }

    .service {
      .desc_container {
        max-width: 100%;
      }
    }

    .service {
      .shadow {
        height: 300px;
        position: absolute;
        top: 0;
        width: 100%;
        background: linear-gradient(
          rgba(0, 0, 0, 0.7) 0%,
          rgba(0, 0, 0, 0.4) 68.57%,
          rgba(0, 0, 0, 0) 100%
        );
      }

      .left_section {
        top: 165px;
        left: 60px;

        .service_title {
          font-size: 28px;
          line-height: 40px;
        }

        .bottom_area {
          padding: 30px 0 0;
          display: flex;
        }

        .du_button {
          padding: 0;
          width: 100px;
          height: 38px;
          font-size: 14px;
        }

        .icon_area {
          padding: 0;

          img {
            width: 40px;
          }

          .service_name {
            font-size: 18px;
            line-height: 30px;
          }
        }
      }

      .anti_section .du_button,
      .mfinder_section .du_button,
      .familycare_section .du_button {
        margin: 0 0 0 54px;
      }

      .eventu_section .du_button {
        margin: 0 0 0 107px;
      }

      .autocall_section .du_button {
        margin: 0 0 0 120px;
      }

      .mnalist_section .du_button {
        margin: 0 0 0 96px;
      }
    }

    .service2 {
      .pin {
        right: 25%;
      }

      .image1 {
        position: absolute;
        z-index: 1;
        top: 52%;
        width: 90%;
        right: 0%;
        transform: translate(0px, -50%);
      }

      .image2 {
        position: absolute;
        right: 60%;
        width: 20%;
        top: 30%;
        transform: translate(0px, -50%);
      }
    }

    .service1 {
      .image1 {
        top: 48%;
        width: 70%;
        transform: translate(0px, -50%);
      }

      .pin2 {
        right: 55%;
        width: 25%;
        top: 68%;
        transform: translate(0px, -50%);
      }
    }

    .service6 {
      .smile {
        top: 17%;
        right: 35%;
        width: 15.5%;
      }

      .image1 {
        top: 53%;
        width: 90%;
        right: 50%;
        transform: translate(50%, -50%);
      }

      .car {
        width: 50%;
        top: 68%;
      }
    }

    .service7 {
      .image1 {
        top: 54%;
        right: 50%;
        transform: translate(50%, -50%);
        width: 110%;
        max-width: none;
      }

      .building {
        width: 25%;
        top: 66%;
        left: 10%;
      }

      .briefcase {
        width: 35%;
        top: 20%;
      }
    }

    .service3 {
      .image1 {
        width: 80%;
        top: 54%;
      }

      .heart {
        right: 60%;
        top: 70%;
        transform: translate(0px, -50%);
      }

      .familycareImg {
        width: 848px;
        top: 60%;
        right: 20%;
      }
    }

    .service4 {
      .image1 {
        width: 90%;
        top: 54%;
        left: -2%;
      }

      .wallet {
        width: 25%;
        top: 53%;
        left: 6%;
      }

      .couponWallet1 {
        width: 30%;
        top: 67%;
        left: -2%;
      }
    }

    .service5 {
      .image1 {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
      }

      .box1 {
        top: 70%;
        right: 67%;
        z-index: 1;
      }

      .box2 {
        top: 73%;
        right: 25%;
        transform: translate(50%, -50%);
      }
    }
  }

  @media screen and (max-width: 883px) {
    //.main_service_bg {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
    .service {
      .desc_container {
        max-width: 100%;
      }
    }

    .swiper-wrapper {
      height: 100dvh;
    }

    .test_lottie {
      width: 360px;
      top: 40%;
      transform: translate(0px, -50%);
    }

    //.du_made_section {
    //  height: 100svh;
    //}
    //.main_banner_section {
    //  height: 100svh;
    //}
    .service2 {
      .pin {
        width: 12%;
        right: 14%;
        z-index: 0;
      }

      .image1 {
        position: absolute;
        z-index: 1;
        top: 60%;
        width: 100%;
        right: 0%;
        transform: translate(0px, -50%);
      }

      .image2 {
        position: absolute;
        right: 60%;
        width: 20%;
        top: 30%;
        transform: translate(0px, -50%);
      }
    }

    .service1 {
      .image1 {
        top: 63%;
        width: 90%;
        right: 50%;
        transform: translate(50%, -50%);
      }

      .pin2 {
        right: 55%;
        width: 30%;
        top: 78%;
        transform: translate(0px, -50%);
      }
    }

    .service6 {
      .image1 {
        top: 58.5%;
        width: 100%;
        transform: translate(0px, -50%);
      }

      .car {
        width: 50%;
        top: 68.5%;
      }

      .smile {
        transform: translate(0px, 50%);
        width: 18.5%;
        right: 33%;
        top: 35%;
      }
    }

    .service7 {
      .image1 {
        top: 65%;
        right: 50%;
        width: 150%;
        max-width: none;
        transform: translate(50%, -50%);
      }

      .building {
        width: 36%;
        left: 0%;
        top: 76%;
      }

      .briefcase {
        width: 40%;
        right: 0%;
        top: 36%;
      }
    }

    .service3 {
      .familycareImg {
        right: 20%;
      }

      .image2 {
        right: 0;
      }

      .heart {
        width: 26%;
        right: 63%;
        top: 75%;
      }
    }

    .service4 {
      .image1 {
        transform: translate(50%, -50%);
        right: 48%;
        top: 60%;
        width: 110%;
      }

      .wallet {
        max-width: 233px;
        width: 47%;
        top: 80%;
        left: -2%;
      }

      .couponWallet1 {
        width: 45%;
        top: 75%;
        right: 10%;
      }
    }

    .service5 {
      .box1 {
        width: 25%;
        top: 75%;
        right: 70%;
        z-index: 1;
      }

      .box2 {
        width: 40%;
        top: 75%;
      }

      .image1 {
        transform: translate(50%, -50%);
        right: 50%;
        top: 60%;
        width: 100%;
      }
    }

    .service {
      .shadow {
        height: 300px;
        position: absolute;
        top: 0;
        width: 100%;
        background: linear-gradient(
          rgba(0, 0, 0, 0.7) 0%,
          rgba(0, 0, 0, 0.4) 68.57%,
          rgba(0, 0, 0, 0) 100%
        );
      }

      .left_section {
        top: 155px;
        bottom: auto;
        left: 21px;
        right: 21px;

        .bottom_area {
          padding: 30px 0 0;
        }

        .du_button {
          padding: 0;
          width: 100px;
          height: 38px;
          font-size: 14px;
        }

        .service_title {
          font-size: 28px;
          line-height: 40px;
        }

        .bottom_area {
          display: flex;
          justify-content: space-between;
        }

        .icon_area {
          padding: 0;

          img {
            width: 40px;
          }

          .service_name {
            padding: 0 0 0 10px;
            font-size: 18px;
            line-height: 30px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    //.swiper,.main_banner_section,.du_made_section {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
    .news_section {
      height: 540px;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    //.swiper,.main_banner_section,.du_made_section {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
    .du_made_section {
      .du_button {
        font-size: 16px;
        line-height: 26px;
      }
    }

    .news_section {
      height: 446px;

      .news_button {
        font-size: 16px;
        line-height: 26px;
      }
    }

    .service_section {
      .title {
        font-size: 46px;
        line-height: 52px;
      }
    }
  }

  @media screen and (max-width: 883px) {
    .swiper {
      //height: calc(var(--vh, 1vh) * 100);
    }

    .main_banner_section {
      // height: 620px;
      //height: calc(var(--vh, 1vh) * 100);
      //min-height: -webkit-fill-available;
      // height: -webkit-fill-available;
      // height: fill-available;
    }

    .pop_icon {
      bottom: 68px;
    }

    .du_made_section {
      //height: calc(var(--vh, 1vh) * 100);
      //height: 604px;
    }

    .news_section {
      height: 694px;
    }
  }
`

export const deaultSection = styled.div`
  h2 {
    font-weight: 800;
    line-height: 70px;
    font-size: 60px;
  }
`

export const SubSection1 = styled(deaultSection)`
  background-image: url(${duMadeImg});
  background-repeat: no-repeat;
  background-size: cover;
  // background-position: center center;
  // background-attachment: fixed;
  width: 100%;
  color: ${STYLE_GUIDE.COLOR.white};

  h2 {
    flex: 0.5;
  }

  .content_wrap {
    //display: flex;
    //justify-content: space-between;
    width: 100%;
    //padding-top: 332px;
    top: 50% !important;
    position: absolute;
    transform: translate(0, -50%) !important;

    .caption {
      opacity: 0;
    }

    h3 {
      font-size: 28px;
      text-align: left;
      font-weight: 400;
      color: ${STYLE_GUIDE.COLOR.gray3};
      padding: 40px 0 0;
    }

    button {
      margin: 140px 0 0;
      font-weight: 700;
      font-size: 18px;
    }
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    button {
      margin-top: 50px;
      font-weight: 700;
      font-size: 18px;
    }

    .content_wrap {
      padding-top: 130px;
      text-align: left;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    h2 {
      font-size: 46px;
      line-height: 52px;
    }

    p {
      padding-top: 30px;
      font-size: 20px;
      line-height: 32px;
      font-weight: 400;
      width: 764px;
      color: ${STYLE_GUIDE.COLOR.gray3};
    }

    .content_wrap {
      //padding-top: 398px;
      display: block;
      text-align: left;

      h3 {
        font-size: 20px;
        line-height: 32px;
        padding: 50px 0 0;
      }

      button {
        margin-top: 60px;
        padding: 11px 20px 13px;
      }
    }
  }

  @media screen and (max-width: 883px) {
    display: block;
    text-align: left;

    h2 {
      font-size: 46px;
      line-height: 52px;
    }

    .content_wrap {
      //padding-top: 198px;
      display: block;
      text-align: left;

      h3 {
        font-size: 20px;
        line-height: 32px;
        padding: 50px 0 60px 0;
      }

      button {
        margin: 0;
        font-size: 16px;
        line-height: 26px;
        padding: 11px 20px 13px;
      }
    }
  }
`

export const SubSection2 = styled(deaultSection)`
  background-color: ${STYLE_GUIDE.COLOR.gray4};
  text-align: left;

  .content_wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 100px;
    // > div {
    //   width: 1061px;
    // }

    h2 {
      flex: 1;
    }

    .news_wrap {
      flex: 1.9;
    }
  }

  h3 {
    font-weight: 700;
    font-size: 36px;
    line-height: 48px;
  }

  p {
    height: 95px;
    margin: 20px 0 50px;
    display: -webkit-box;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    color: ${STYLE_GUIDE.COLOR.gray1};
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    // .content_wrap {
    //   > div {
    //     width: 657px;
    //   }
    // }
    p {
      height: 125px;
      -webkit-line-clamp: 4;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    .content_wrap {
      padding-top: 80px;
      display: block;
      // width: 764px;

      > div {
        padding-top: 30px;
      }
    }

    h2 {
      font-weight: 800;
      font-size: 46px;
      line-height: 52px;
    }

    h3 {
      font-weight: 700;
      font-size: 22px;
      line-height: 34px;
    }

    p {
      margin: 20px 0px 40px;
      font-weight: 400;
      font-size: 18px;
      line-height: 30px;
      height: 95px;
      -webkit-line-clamp: 3;
    }

    button {
      padding: 11px 20px 13px;
    }
  }

  @media screen and (max-width: 883px) {
    .content_wrap {
      display: block;

      > div {
        padding: 70px 0 0 0;
      }
    }

    h2 {
      font-size: 46px;
      line-height: 52px;
    }

    h3 {
      font-size: 22px;
      line-height: 34px;
      width: 320px;
    }

    .news_content {
      height: 120px;
      margin: 20px 0px 40px;
      -webkit-line-clamp: 4;
      line-height: 30px;
    }

    .button {
      font-weight: 700;
      font-size: 16px;
      line-height: 26px;
      padding: 11px 20px 13px;
    }
  }
`

export const SubSection3 = styled(deaultSection)`
  position: relative;
  overflow: hidden;

  .service_main > div > svg {
    height: 100% !important;
    width: 100% !important;
  }

  .lottie_bg {
    opacity: 80%;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
  }

  .service_container {
    width: 500%;
    height: 100vh;
    display: flex;
    flex-wrap: noWrap;
  }

  .service {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;

    .anti_section,
    .mfinder_section {
      width: 100%;
      height: 100%;

      .image_wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        top: 50%;
        transform: translate(0px, -50%);
      }
    }

    .left_section {
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translate(0, -50%);

      .service_title {
        font-weight: 700;
        font-size: 56px;
        line-height: 72px;
        color: #ffffff;
      }

      .icon_area {
        display: flex;
        text-align: center;
        align-items: center;
        padding: 50px 0 120px;

        .service_name {
          padding: 0 0 0 20px;
          font-weight: 400;
          font-size: 36px;
          line-height: 48px;
          color: #ffffff;
        }
      }
    }
  }

  .service2 {
    .pin {
      width: 4%;
      right: 50%;
      position: absolute;
    }

    .image1 {
      position: absolute;
      z-index: 1;
      top: 50%;
      width: 50%;
      right: 5%;
      transform: translate(0px, -50%);
    }

    .image2 {
      position: absolute;
      right: 51%;
      top: 70%;
      transform: translate(0px, -50%);
    }
  }

  .service1 {
    .image1 {
      right: 120px;
      position: absolute;
      z-index: 1;
      top: 50%;
      width: 40%;
      transform: translate(0px, -40%);
    }

    .pin2 {
      top: 50%;
      z-index: 2;
      width: 21%;
      right: 46%;
      position: absolute;
    }
  }

  .service6 {
    .car {
      width: 30%;
      right: -5%;
      position: absolute;
      bottom: 0;
      z-index: 2;
    }

    .smile {
      width: 11.5%;
      right: 24%;
      position: absolute;
      top: 83px;
      z-index: 2;
    }

    .image1 {
      right: 124px;
      position: absolute;
      top: 30px;
      z-index: 1;
    }
  }

  .service6 {
    .heart {
      width: 19%;
      right: 46%;
      position: absolute;
      bottom: 0;
      z-index: 2;
    }

    .image1 {
      right: 8%;
      position: absolute;
      z-index: 1;
    }

    .image2 {
      right: -18%;
      position: absolute;
      top: 0;
    }
  }

  .service5 {
    .image1 {
      right: 184px;
      position: absolute;
      z-index: 1;
      top: 69px;
    }
  }

  .lottie_color1 {
    background-color: #67c51d;
  }

  .lottie_color2 {
    background-color: #006d3f;
  }

  .lottie_color3 {
    background-color: #e3112a;
  }

  .lottie_color4 {
    background-color: #00479a;
  }

  .lottie_color5 {
    background-color: #6111e3;
  }

  .lottie_color6 {
    background-color: #008cc8;
  }

  .mySwiper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .service2 {
      .pin {
        width: 3.5%;
      }

      .image1 {
        width: 62%;
      }

      .image2 {
        width: 16%;
        right: 46%;
      }
    }

    .service1 {
      .image1 {
        width: 33%;
        right: 50px;
      }
    }

    .service6 {
      .smile {
        width: 9%;
      }

      .image1 {
        width: 61%;
        right: 0%;
      }
    }

    .service4 {
      .image1 {
        width: 48%;
      }

      .image2 {
        width: 96%;
      }
    }

    .service5 {
      .image1 {
        width: 53%;
        right: 8%;
      }
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    .service {
      .left_section {
        bottom: 70px;
        top: auto;

        .service_title {
          font-size: 28px;
          line-height: 40px;
        }

        .bottom_area {
          display: flex;
        }

        .icon_area {
          padding: 30px 0 0;

          img {
            width: 40px;
          }

          .service_name {
            font-size: 18px;
            line-height: 30px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 883px) {
    .service {
      .left_section {
        bottom: 70px;
        top: auto;

        .service_title {
          font-size: 28px;
          line-height: 40px;
        }

        .bottom_area {
          display: flex;
        }

        .icon_area {
          padding: 30px 0 0;

          img {
            width: 40px;
          }

          .service_name {
            font-size: 18px;
            line-height: 30px;
          }
        }
      }
    }
  }
`

export const SubSection4 = styled(deaultSection)`
  padding: 130px 0;
  // padding: 550px 0 0 0;

  .story_box {
    display: flex;
    padding: 40px 0 0 0;
    justify-content: space-between;

    &:hover {
      .story_item.active {
        .img_box img {
          transform: scale(1.15);
        }

        .story_content {
          img {
            transform: translate(8px, -8px);
          }
        }
      }
    }
  }

  .story_item {
    .box {
      width: 780px;
      height: 380px;
      overflow: hidden;
      border-radius: 40px;
    }

    .img_box > img {
      cursor: pointer;
      display: block;
      transition: all 0.2s ease;
    }
  }

  .story_content {
    padding: 30px 0 0 0;
    display: flex;
    align-items: center;
    position: relative;

    h3 {
      font-weight: 700;
      font-size: 36px;
      line-height: 48px;
      color: ${STYLE_GUIDE.COLOR.black1};
    }

    img {
      padding: 0 0 0 9px;
      width: 17px;
      // top: 40px;
      // left: 130px;
      // position: absolute;
      transition: all 0.2s ease;
    }
  }

  p {
    padding: 6px 0 0 0;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    color: ${STYLE_GUIDE.COLOR.gray1};
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .story_box {
      padding: 30px 0 0 0;

      &:hover {
        .story_item.active {
          .story_content {
            img {
              top: 20px;
              left: 140px;
            }
          }
        }
      }
    }

    .story_item {
      .box {
        width: 485px;
        height: 236px;
      }
    }

    .story_content {
      padding: 20px 0 0 0;

      img {
        top: 30px;
      }
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    // padding: 357px 0px 0px;
    padding: 100px 0px;

    .title {
      font-size: 46px;
      line-height: 52px;
    }

    .story_box {
      padding: 30px 0 0 0;
    }

    .story_item {
      .box {
        width: 367px;
        height: 218px;
      }

      p {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
      }
    }

    .story_content {
      padding: 10px 0 0 0;

      h3 {
        font-size: 24px;
        line-height: 36px;
      }

      img {
        left: 95pxpx;
        top: 20px;
      }
    }
  }

  @media screen and (max-width: 883px) {
    padding: 100px 0;
    .title {
      font-size: 46px;
      line-height: 52px;
    }

    .story_box {
      display: flex;
      flex-direction: column;
      padding: 30px 0 0 0;
    }

    .story_item {
      .box {
        width: 320px;
        height: 190px;
        border-radius: 30px;
      }

      p {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        padding: 0;
      }

      &:first-child {
        padding: 0 0 30px 0;
      }
    }

    .story_content {
      padding: 10px 0px 0px;

      h3 {
        font-size: 24px;
        line-height: 36px;
      }

      img {
        padding: 0 0 0 10px;
        // width: 17px;
        // padding: 0;
        // top: 20px;
      }
    }
  }
`
export const SubSection5 = styled(deaultSection)`
  padding: 130px 0 0;
  isolation: isolate;

  // background: url(${recruitImg}) no-repeat 50% 100% / cover;
  // background-attachment: fixed;

  .recruit {
    isolation: isolate;
    display: block;
    padding: 152px 0 152px 137px;
    border-radius: 40px;
    color: ${STYLE_GUIDE.COLOR.white};

    .recruit_content {
      padding: 20px 0 50px;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
    }

    .recruit_title {
      font-weight: 700;
      font-size: 46px;
      line-height: 62px;
    }
  }

  .react-parallax-bgimage {
    top: -200px;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .recruit {
      padding: 122px 90px;
    }

    .react-parallax-bgimage {
      top: -100px;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    padding: 100px 0 0;
    .recruit {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 66px 255px;

      .recruit_title {
        font-size: 28px;
        line-height: 40px;
      }

      .recruit_content {
        font-size: 14px;
        line-height: 24px;
        padding: 10px 0 40px 0;
      }

      .recruit_btn {
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }

    .react-parallax-bgimage {
      top: 0;
    }
  }

  @media screen and (max-width: 883px) {
    padding: 100px 0 0;
    text-align: center;

    .recruit {
      padding: 116px 30px;
      text-align: center;
      background-size: 250%;

      .recruit_content {
        font-size: 14px;
        line-height: 24px;
        padding: 10px 0 40px 0;
      }

      .recruit_title {
        font-size: 28px;
        line-height: 40px;
      }

      .recruit_btn {
        display: flex;
        justify-content: center;
      }
    }

    .react-parallax-bgimage {
      top: 0;
    }
  }
`
